import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import Loading from "components/Loading";
import { find, get } from "lodash";
import { useCollectionLoteria } from "utils/methods/firebaseBingo";

const StudentConfirm = ({ studentSubmission, bingoResponse, currentUser }) => {
    const [loader, setLoader] = useState(false);
    const [studentModal, setStudentModal] = useState(false);
    const { updateStudentEnter } = useCollectionLoteria();
    const UserSubmissions = find(studentSubmission, (item) => item?.user_id === get(currentUser, "id"));

    useEffect(() => {
        const UserSubmissions = find(studentSubmission, (item) => item?.user_id === get(currentUser, "id"));
        if (!UserSubmissions?.user_grade && bingoResponse?.id) {
            setStudentModal(true);
        } else {
            setStudentModal(false);
        }
    }, [studentSubmission, bingoResponse]);

    const onClose = async () => {
        await updateStudentEnter(bingoResponse?.id, get(currentUser, "id"))
        setStudentModal(false);
    }

    return (
        <Modal
            open={studentModal}
            maskClosable={false}
            closable={false}
            footer={null}
            centered
            width={350}
            className="custom-modal"
        >
            <div className="flex flex-col items-center text-center p-4">
                <CheckCircleFilled className="text-blue-500 text-5xl" style={{ fontSize: 50, color: '#010A53' }} />
                <h2 className="text-lg font-semibold mt-4 text-gray-800" style={{ color: '#010A53' }}>Get Ready!</h2>
                <p className="text-gray-500 text-sm mt-2">
                    Your Lotería game is about to begin.
                    Click Start to continue.
                </p>
                <Button
                    type="primary"
                    className="mt-4 px-6"
                    onClick={async () => {
                        setLoader(true);
                        await onClose();
                        setLoader(false);
                    }}
                    style={{
                        borderRadius: '8px',
                        backgroundColor: '#010A53',
                        borderColor: '#010A53',
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                >
                    {loader ? <Loading size={20} white /> : 'Start Lotería'}
                </Button>
            </div>
        </Modal>
    );
};

export default StudentConfirm;
